import React from "react";

import * as R from "ramda";

import { Box, Flex, Button, Text } from "src/components/base";

import Downshift from "downshift";

import { withContentRect } from "react-measure";

import { Arrow } from "src/icons";

const defaultItemRenderer = ({ item, colors, itemToString, ...props }) => (
  <Flex flexDirection="column">
    <Text color={colors.color} fontWeight="semibold" fontSize={4}>
      {itemToString(item)}
    </Text>
    {item.subLabel && (
      <Text color={colors.color} inline={true} fontWeight="light" fontSize={2}>
        {item.subLabel}
      </Text>
    )}
  </Flex>
);

const defaultValueRenderer = ({ value, placeholder }) => (
  <Text color={value ? "black" : "placeholder"} align="left">
    {value || placeholder}
  </Text>
);

const getItemColors = ({ isSelected, isActive }) => {
  if (isSelected) {
    return {
      bg: "green",
      color: "white",
      mutedColor: "white",
    };
  }

  return isActive
    ? {
        bg: "hover",
        mutedColor: "muted",
      }
    : {
        bg: "white",
        mutedColor: "muted",
      };
};

const Item = ({ item, render, ...props }) => {
  const colors = getItemColors(props);

  return (
    <Box
      {...props}
      {...colors}
      style={{ cursor: "pointer" }}
      className="dropdown-item"
      {...item.itemProps}
    >
      {render({ item, colors, ...props })}
    </Box>
  );
};

const Dropdown = ({
  onChange,
  placeholder,
  items,
  renderItem = defaultItemRenderer,
  renderValue = defaultValueRenderer,
  itemToString = item => (item ? item.label || item.value : ""),
  getSelectedItemObject = (value, items) =>
    R.find(R.propEq("value", value), items),
  value,
  measureRef,
  measure,
  contentRect,
  id,
  borderRadius = 5,
}) => (
  <Downshift
    selectedItem={value}
    onChange={onChange}
    itemToString={itemToString}
    render={({
      isOpen,
      getButtonProps,
      getRootProps,
      getItemProps,
      highlightedIndex,
      selectedItem,
      itemToString,
    }) => (
      <Flex
        {...getRootProps({
          refKey: "innerRef",
        })}
        flexDirection="column"
        flex="1 0 auto"
      >
        <Button
          {...getButtonProps()}
          borderColor="divider"
          bg="white"
          borderWidth={1}
          borderRadius={borderRadius}
          py={2}
          px={[2, 3]}
          flex="1 0 auto"
          style={{
            cursor: "pointer",
          }}
          align="center"
          justify="space-between"
          id={id}
        >
          {renderValue({
            value: itemToString(getSelectedItemObject(value, items)),
            placeholder,
          })}
          <Arrow size={12} color="divider" direction="down" />
        </Button>
        <div style={{ position: "relative", zIndex: 1000 }}>
          {isOpen && (
            <Box
              style={{
                overflowY: "scroll",
                position: "absolute",
                left: 0,
                right: 0,
                top: contentRect.bounds.height
                  ? -1 * contentRect.bounds.height
                  : 0,
                maxHeight: 300,
              }}
              bg="white"
              borderWidth={1}
              borderColor="divider"
              borderRadius={borderRadius}
            >
              {items.map((item, index) => (
                <Item
                  px={3}
                  py={2}
                  item={item}
                  itemToString={itemToString}
                  {...getItemProps({
                    item: item.value,
                    isActive: highlightedIndex === index,
                    isSelected: selectedItem === item.value,
                  })}
                  key={item.value}
                  render={renderItem}
                />
              ))}
            </Box>
          )}
        </div>
      </Flex>
    )}
  />
);

export default withContentRect("bounds")(Dropdown);



// WEBPACK FOOTER //
// ./src/components/Dropdown.js